import { render, staticRenderFns } from "./ProblemFilters.vue?vue&type=template&id=5a27c432&scoped=true&"
import script from "./ProblemFilters.vue?vue&type=script&lang=js&"
export * from "./ProblemFilters.vue?vue&type=script&lang=js&"
import style0 from "./ProblemFilters.vue?vue&type=style&index=0&id=5a27c432&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a27c432",
  null
  
)

component.options.__file = "ProblemFilters.vue"
export default component.exports